import { useEffect, useState } from "react";
import { NAV } from "@/constants/testIds";
import { useT } from "@/lib/i18n";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const { lang, setLang, t } = useT();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "services", label: t.nav.services, testId: NAV.linkServices },
    { id: "work", label: t.nav.work, testId: NAV.linkWork },
    { id: "process", label: t.nav.process, testId: NAV.linkProcess },
    { id: "contact", label: t.nav.contact, testId: NAV.linkContact },
  ];

  return (
    <nav
      data-testid={NAV.root}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0a0a0a]/85 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid={NAV.logo}
          className="flex items-center gap-2 group"
        >
          <span className="font-display text-2xl tracking-tight text-white group-hover:text-[#ff3b00] transition-colors">
            BODEGA
          </span>
          <span className="hidden sm:inline-block font-mono text-[10px] tracking-[0.25em] text-white/40 mt-1">
            {t.nav.tagline}
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8 font-mono text-xs tracking-[0.2em] uppercase">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={l.testId}
              className="text-white/60 hover:text-white relative group transition-colors"
            >
              <span className="text-[#ff3b00] mr-1">/</span>
              {l.label}
              <span className="absolute left-0 -bottom-1 w-0 h-px bg-[#ff3b00] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3 md:gap-5">
          {/* Language toggle */}
          <div
            data-testid="lang-toggle"
            role="group"
            aria-label="Language toggle"
            className="inline-flex items-center font-mono text-[10px] md:text-xs tracking-[0.2em] uppercase border border-white/15 divide-x divide-white/15"
          >
            <button
              type="button"
              data-testid="lang-en"
              aria-pressed={lang === "en"}
              onClick={() => setLang("en")}
              className={`px-2.5 md:px-3 py-1.5 transition-colors ${
                lang === "en"
                  ? "bg-[#ff3b00] text-black"
                  : "text-white/60 hover:text-white"
              }`}
            >
              EN
            </button>
            <button
              type="button"
              data-testid="lang-es"
              aria-pressed={lang === "es"}
              onClick={() => setLang("es")}
              className={`px-2.5 md:px-3 py-1.5 transition-colors ${
                lang === "es"
                  ? "bg-[#ff3b00] text-black"
                  : "text-white/60 hover:text-white"
              }`}
            >
              ES
            </button>
          </div>

          <a
            href="#contact"
            data-testid="nav-cta-contact"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 border border-white/20 hover:border-[#ff3b00] hover:text-[#ff3b00] font-mono text-xs tracking-[0.2em] uppercase transition-colors"
          >
            {t.nav.hire}
          </a>
        </div>
      </div>
    </nav>
  );
};
